import { showFooterActions } from '../../services';

export const showFooterReducer = (state={show:true}, action)=>{
    switch(action.type){
        case showFooterActions.SHOW:
            return {...state, ["show"]:true};
        case showFooterActions.HIDE:
            return {...state, ["show"]:false};
        default:
            return state;
        }
}